"use client"

import {useEffect, useState} from 'react';
import {gpxRequest} from "@/utils/api/Gpx";
import {Point} from "@we-gold/gpxjs";
import {GpxFile} from "@/types/Paths";

const useMapBounds = (gpxs?: Array<GpxFile>) => {
  const [data, setData] = useState<google.maps.LatLngBounds | undefined>(undefined)

  const fetchData = async (gpx: GpxFile) => {
    if (!gpx.url) return null
    const fetched = await gpxRequest(gpx.url)
    if (fetched) {
      return fetched
    }
  }

  useEffect(() => {
    const getBounds = (async () => {
      if (typeof window === "undefined" || !window.google || !window.google.maps) return
      const bound = new google.maps.LatLngBounds()
      gpxs?.forEach(async (gpx: GpxFile) => {
        await fetchData(gpx).then(
          (track) => {
            if (!track) return
            track?.points.map((point: Point) => {
              bound.extend({lat: point.latitude, lng: point.longitude})
            })
            setData(bound)
          }
        )
      })
    })
    if (!data && gpxs) {
      getBounds()
    }
  }, [data, gpxs]);

  return data
};

export default useMapBounds;
